'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxConnect = require('redux-connect');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _reactRedux = require('react-redux');

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _statistics2 = require('selectors/statistics');

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _TrackDetailsStatistics = require('components/Statistics/TrackDetailsStatistics/TrackDetailsStatistics');

var _TrackDetailsStatistics2 = _interopRequireDefault(_TrackDetailsStatistics);

var _StatisticsRecipientBackButton = require('components/Statistics/StatisticsRecipientBackButton/StatisticsRecipientBackButton');

var _StatisticsRecipientBackButton2 = _interopRequireDefault(_StatisticsRecipientBackButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./ProjectDetailsStatistics.scss');

var ProjectDetailsStatistics = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch,
        projectId = _ref.params.projectId;
    return (0, _asyncPromise2.default)(dispatch(statisticsActions.loadTracksDetailsStats({ projectId: Number(projectId) })).promise);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    endDate: state.statistics.endDate,
    projectId: Number(ownProps.params.projectId),
    startDate: state.statistics.startDate,
    tracksDetailsData: (0, _statistics2.getTracksDetailsData)(state),
    tracksDetailsLoading: state.statistics.tracksDetailsStatsLoading
  };
}, (0, _extends3.default)({}, statisticsActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ProjectDetailsStatistics, _Component);

  function ProjectDetailsStatistics() {
    (0, _classCallCheck3.default)(this, ProjectDetailsStatistics);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectDetailsStatistics.__proto__ || (0, _getPrototypeOf2.default)(ProjectDetailsStatistics)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectDetailsStatistics, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var projectId = nextProps.projectId,
          startDate = nextProps.startDate,
          endDate = nextProps.endDate;

      var isDateChanged = startDate !== this.props.startDate || endDate !== this.props.endDate;
      if (isDateChanged && startDate && endDate) {
        this.props.loadTracksDetailsStats({ projectId: projectId, startDate: startDate, endDate: endDate });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          projectId = _props.projectId,
          tracksDetailsData = _props.tracksDetailsData,
          tracksDetailsLoading = _props.tracksDetailsLoading;


      return _react2.default.createElement(
        'div',
        { className: styles.newComponent },
        _react2.default.createElement(_StatisticsRecipientBackButton2.default, { referrer: 'project', projectId: projectId }),
        _react2.default.createElement(_Loader2.default, { show: tracksDetailsLoading, alignCenter: true }),
        tracksDetailsData.map(function (trackDetails) {
          return _react2.default.createElement(_TrackDetailsStatistics2.default, { key: trackDetails.trackId, data: trackDetails });
        })
      );
    }
  }]);
  return ProjectDetailsStatistics;
}(_react.Component), _class2.propTypes = {
  endDate: _propTypes2.default.string,
  loadTracksDetailsStats: _propTypes2.default.func,
  projectId: _propTypes2.default.number,
  startDate: _propTypes2.default.string,
  tracksDetailsData: _propTypes2.default.array,
  tracksDetailsLoading: _propTypes2.default.bool
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  tracksDetailsData: []
}, _temp)) || _class) || _class);
exports.default = ProjectDetailsStatistics;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Statistics/ProjectDetailsStatistics/ProjectDetailsStatistics.js
// module id = 2212
// module chunks = 1